import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { useSitecore } from '@sitecore-content-sdk/nextjs';
import React, { JSX } from 'react';
import { formatInTimeZone } from 'date-fns-tz';

type TeachingSheetRaw = {
  disclaimerMessage: { value: string };
  draftNumber: { value: string };
  lastReviewDate: { value: string };
};

const TeachingSheetsInfo = (): JSX.Element => {
  const { page } = useSitecore();
  const route = page.layout.sitecore?.route;
  const teachingSheetData = route?.fields as TeachingSheetRaw;
  const reviewedDate = teachingSheetData.lastReviewDate?.value;

  const isValidReviewedDate =
    reviewedDate &&
    reviewedDate !== '0001-01-01T00:00:00Z' &&
    !isNaN(new Date(reviewedDate).getTime());

  const formattedReviewedDate = isValidReviewedDate
    ? formatInTimeZone(reviewedDate, 'UTC', 'MMMM d, yyyy')
    : null;

  return (
    <div className="max-w-screen-xxl mx-auto px-10 lg:px-[80px] lg:flex justify-between pb-[48px] gap-[24px] w-full print:break-inside-avoid">
      <div className="pb-[24px] lg:pb-0">
        <p className="text-12 leading-31 font-bold font-centuryGothic text-gray-900 mb-4">
          <span className="pr-10">Draft Number: {teachingSheetData.draftNumber.value}</span>
          {formattedReviewedDate && (
            <span className="pl-10">Revision Date: {formattedReviewedDate}</span>
          )}
        </p>
        <div className="text-12 text-gray-900 leading-31 font-centuryGothic">
          <RichTextWrapper field={teachingSheetData.disclaimerMessage} />
        </div>
      </div>
    </div>
  );
};

export default TeachingSheetsInfo;
